// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__wIxQp","right":"Footer_right__2hWTQ","buttons":"Footer_buttons__SfuAY"};